module.exports = __webpack_public_path__ + "static/img/1973_phase_function_Paper_Points.2ec214b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1973_phase_function_Paper_Points.png
// module id = bjhS
// module chunks = 0